jQuery(window).bind("pageshow", function(event) {
  jQuery(".preloader").hide();
});

jQuery(document).ready(function() {
  var $html = $(document.documentElement);
  
  $(".build-price__btn").on("click", function(e) {
    e.preventDefault();
    $("#popup-plan").addClass("active");
    $html.css('overflow', 'hidden');
  });
  
  $(".close-btn").on("click", function(e) {
    e.preventDefault();
    $("#popup-plan").removeClass("active");
    $html.css('overflow', '');
  });
  
  $(".add-to-cart-player, .add-player-btn").on("click", function(e) {
    e.preventDefault();
    var $this = jQuery(this);
    var player = $this.attr('data-player');
  
    if ( player ) {
      $(".preloader").show();
      
      var player_data = {
        "id": player,
        "quantity": 1
      };

      jQuery.ajax({
          type: "POST",
          url: '/cart/clear.js',
          dataType: 'json',
          success: function(){
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: player_data,
              dataType: "json",
              success: function (response) {
                window.location.href = '/checkout';
              },
              error: function(xhr, status, error) {
                $(".preloader").hide();
                alert(xhr.responseJSON.description);
              }
            });
          },
          error: function(xhr, status, error) {
            $(".preloader").hide();
            alert(xhr.responseJSON.description);
          }
      });
    }
  });
});
